export default __webpack_public_path__ + "static/media/map-light.6ec97232.png";